export default "__VITE_ASSET__ccip_ENa__"